import { TMasterdataListDB } from '@monorepo/types';
import produce from 'immer';
import { INITIAL_CACHE_RESET_TIMESTAMP } from '../metadata/metadata.reducer';
import { InputAppMasterdataListDBActionTypes, TInputAppMasterdataListActions } from './master-data-list-db.actions';
export function getMasterdataListInitialState(nextCacheResetTimestamp: number): TMasterdataListDB {
  return {
    nextCacheResetTimestamp: nextCacheResetTimestamp,
    allMasterdataListsByBctx: {},
    silhouetteKeysInfo: {
      keys: {},
    },
    correctiveReasons: {
      result: [],
    },
    masterdataListV2: {},
    rcaHierarchicalData: {
      categories: [],
    },
  };
}
export const masterdataListDBInitialState: TMasterdataListDB =
  getMasterdataListInitialState(INITIAL_CACHE_RESET_TIMESTAMP);
export function InputAppMasterdataListsStateReducer(
  state: TMasterdataListDB = masterdataListDBInitialState,
  action: TInputAppMasterdataListActions,
): TMasterdataListDB {
  switch (action.type) {
    case InputAppMasterdataListDBActionTypes.SetSilhouetteInfoAndDownloadSilhouetteAssets:
    case InputAppMasterdataListDBActionTypes.SetSilhouetteInfo:
    case InputAppMasterdataListDBActionTypes.SetSilhouetteInfoAndLoadSilhouetteOperations:
      return produce(state, (draft) => {
        draft.silhouetteKeysInfo = action.silhouetteKeysInfo;
      });
    case InputAppMasterdataListDBActionTypes.SetAllMasterdataListsAndLoadSilhouetteInfo:
    case InputAppMasterdataListDBActionTypes.SetMasterdataListsStoreAndLoadAllMasterdataListsAndSilhouetteKeys:
    case InputAppMasterdataListDBActionTypes.UpdateMasterdataListStore:
    case InputAppMasterdataListDBActionTypes.UpdateFilteredListsSuccess:
    case InputAppMasterdataListDBActionTypes.UpdateFilteredListsV3Success:
    case InputAppMasterdataListDBActionTypes.SetAllMasterdataListsV2AndLoadAllMasterdataLists:
    case InputAppMasterdataListDBActionTypes.SetMasterdataListsStore:
    case InputAppMasterdataListDBActionTypes.UpdateMasterdataListStoreAndDownloadSilhouetteAssets:
    case InputAppMasterdataListDBActionTypes.UpdateMasterdataListStoreAndEmitSizeListLoadedSubscription:
      return {
        ...action.masterdataListDB,
      };
    default:
      return state;
  }
}
